const riot = require('riot');

riot.tag2('module-view-list', '<div class="f fclm s-full"> <div class="px16 mb10" data-is="module-note-filter" ref="filter" users="{projectUsers}" enable-closed="{true}"></div> <div class="s-full px16 pb16 overflow-hidden"> <div class="bg-white s-full box-shadow-primary rounded-12 overflow-hidden"> <div class="f h-full"> <div class="f flex-column s-full bg-background_light_secondary z0" ref="notesbar"> <div class="f fclm s-full"> <div class="w-full bg-background_light_secondary border-bottom py10"> <div class="f fh px30"> <div class="w-full mb10" data-is="module-button-note-create" project="{project}"></div> </div> <div class="f fbw fm w-full px16 py6"> <div class="fs10 lh15 bold text-primary cursor-pointer" onclick="{onLookAllNote}">全て既読</div> <div class="f fm cursor-pointer s-hide" onclick="{toggleUnreadFilter}"> <div class="fs12 mr6">未読メッセージ</div> <div data-is="atom-switch" ref="unread_switch" checked="{isUnreadFiltered()}" is-alert="{true}"></div> </div> </div> </div> <div class="f fc fclm p32" if="{shouldShowClosedNoteAnnouncement()}"> <div class="text-center lh16 mb16">更新されたノート、またはクローズされたノートに未読が残っているかもしれません。</div> <button class="relative button primary" onclick="{filterUnreadAndClose}">未読ノートを確認 <div class="absolute tn6 rn6 fh f s18 circle bg-alert_primary fs11 text-white font-lato" if="{getUnreadInboxCount()}">{getUnreadInboxCount()}</div> </button> </div> <div class="overflow-scroll w-full animation-appear" show="{getItems()}" ref="body" onscroll="{onScroll}"> <div class="border-bottom" each="{note in getNotes()}" data-is="item-note" item="{note}" is-current="{note.id === parent.note.id}" enable-active-border="{true}" view="list"></div> </div> <div class="p16 f fh {\'h-full\' : !observers.length}" if="{!observers.length || !isLoadedNotes}"> <div data-is="atom-loading"></div> </div> </div> </div> <div class="relative s-hide" ref="notebar"> <div class="s-full" show="{!isEmpty()}" data-is="module-note" ref="note"></div> <div class="s-full f fh fclm animation-appear" if="{isEmpty()}"> <div class="fs20 bold text-center lh20 text-label_dark_primary mb24"><br>{app.store.project.data.name}へようこそ!<br>まずはノートを作成してみましょう。</div> <button class="button primary max-width-330 w-full py10 bold transition" ref="create" onclick="{onCreateNote}">ノートを作成</button> </div> </div> <div class="relative border-left s-hide" ref="messagebar"> <div class="absolute trbl0" show="{!isEmpty()}"> <div class="s-full" data-is="module-messages" ref="messages"></div> </div> </div> </div> </div> </div> </div>', 'module-view-list,[data-is="module-view-list"]{display:block}', '', function(opts) {
    this.notesLimit = 32;
    this.on('mount', () => {
      this.refs.filter.on('filterchange', () => {

        app.utils.replaceLocationParams({
          q: this.refs.filter.getQueryValue().trim(),
        });

        this.refs.unread_switch.setValue(this.isUnreadFiltered());

        this.update();
      });

      this.tags['module-button-note-create'].on('notecreate', ({note}) => {
        spat.router.push(`/${this.project.path}/notes/${note.id}?view=list`);
      });

      this.onCreateNote = async () => {
        const note = await app.store.project.createNote({content:'# '});
        spat.router.push(`/${app.store.project.path}/notes/${note.id}?view=list`);
      };

      if (spat.isBrowser && !app.useragent.isMobile) {
        app.utils.split([
          this.refs.notesbar,
          this.refs.notebar,
          this.refs.messagebar,
        ], {
          storageKey: 'split_view_list',
          defaultSizes: [20, 60, 20],
          minSizes: [300, null, 300],
        });
      }
    });

    this.on('unmount', () => {

      if (this.observers) {
        this.observers.forEach(observer => {
          observer.unobserve();
        });
      }
    });

    this.setup = async ({note_id}, {req}) => {

      app.shortcut.setView('list', { noteTag: this.refs.note, viewTag: this });

      let project = app.store.project;

      if (!note_id) {
        let project_user = project.findProjectUser();
        if (project_user) {
          note_id = project_user.data.last_looked_note_id;
        }
      }

      if (note_id) {
        let note = project.collection('notes').doc(note_id);
        this.refs.note.setNote(note).catch(app.utils.confirmReload);
        this.refs.messages.setNote(note).catch(app.utils.confirmReload);

        this.update({note});
      }

      if (req.query.q) {
        this.refs.filter.setQueryValue(decodeURIComponent(req.query.q));
      }
      this.update();

      if (this.project === project) return ;
      this.update({
        project,
      });

      if (this.observers) {
        this.observers.forEach(observer => {
          observer.unobserve();
        });
      }

      this.observers = [];

      this.notesStore = this.project.collection('notes')
        .where('disabled', '==', false)
        .orderBy('pinned', 'desc')
        .orderBy('last_commented_at', 'desc')
        .limit(this.notesLimit);

      await this.fetchMore();

      this.projectUsers = await this.project.fetchProjectUsers();

      this.update();
    };

    this.getItems = () => {

      let items = _.flatten(this.observers.map(o => o.items));
      return items;
    };

    this.getNotes = () => {
      let query = this.refs.filter.getQuery();
      let items = this.getItems();

      if (!query.options?.closed) {
        items = items.filter(item => !item.data.archived);
      }
      return app.utils.filterNotes(items, query);
    };

    this.onLookAllNote = async () => {
      let result = await spat.modal.confirm('このプロジェクトを全て既読にしますか?');
      if (!result) return;
      await app.store.project.lookAllNote();
      app.utils.openToast('allRead');
    };

    this.onScroll = (e) => {
      let {scrollHeight , scrollTop, clientHeight} = e.currentTarget;
      let is_scroll_end = scrollHeight - scrollTop - 2 <= clientHeight;
      e.preventUpdate = true;

      if (is_scroll_end) {
        this.debouncedFetchMore();
      }
    };

    this.focusNoteFilter = () => {
      this.refs.filter.focus();
    };

    this.focusMessage = () => {
      this.refs.messages.focusEditor();
    };

    this.clickAssignedCheckbox = () => {
      this.refs.filter.clickAssignedCheckbox();
    };

    this.fetchMore = async () => {

      let lasted_observer = this.observers[this.observers.length-1];
      if (lasted_observer) {
        if (lasted_observer.items.length < this.notesLimit) return ;
        let lasted_item = lasted_observer.items[lasted_observer.items.length-1];
        if (lasted_item) {
          this.notesStore.startAfter(lasted_item.doc);
        }
      }

      this.isLoadedNotes = false;
      this.update();

      let observer = this.notesStore.observer(() => {
        this.update();

        observer.items.forEach(async item => {
          await item.relate();
          app.utils.debouncedUpdate();
        });
      });

      await observer.observe();

      this.observers.push(observer);

      this.isLoadedNotes = true;

      this.update();
    };

    this.debouncedFetchMore = _.debounce(this.fetchMore, 128, true);

    this.isEmpty = () => {
      return this.isLoadedNotes && !this.getItems().length;
    };

    this.getUnreadInboxCount = () => {
      let project_user = this.project && this.project.findProjectUser();
      if (!project_user) return 0;
      return project_user.getInboxes({ looked: false }).length;
    };

    this.shouldShowClosedNoteAnnouncement = () => {
      let { options } = this.refs.filter.getQuery();

      for (let key in options) {
        if (key !== 'unread' && options[key]) {
          return false;
        }
      }

      return options.unread && !this.getNotes().length && this.getUnreadInboxCount();
    };

    this.filterUnreadAndClose = () => {
      let q = 'unread:true closed:true';
      this.refs.filter.setQueryValue(q);
    };

    this.isUnreadFiltered = () => {
      let { options } = this.refs.filter.getQuery();
      return options.unread;
    };

    this.toggleUnreadFilter = () => {
      capacitor.hapticsImpactLight();

      let is_unread = this.isUnreadFiltered();
      let query = is_unread ? '' : 'unread:true';

      this.refs.filter.setQueryValue(query);
    };
});